import styled from 'styled-components';

export const Container = styled.div`
  --green-700: #0f6e47;
  --green-600: #178a57;
  --green-500: #1fa56b;
  --green-400: #34c285;
  --green-100: #c9efdb;
  --green-50: #e8f5ee;
  --ink-900: #0f1a2e;
  --ink-800: #1a2540;
  --ink-700: #3d4a5c;
  --ink-500: #6b7280;
  --ink-400: #94a0b0;
  --ink-300: #c2cad4;
  --bg: #f4f6f7;
  --bg-soft: #fafbfc;
  --card: #ffffff;
  --border: #e5e7eb;
  --border-strong: #d1d5db;
  --warning: #b45309;
  --warning-bg: #fef3c7;
  --danger: #b91c1c;
  --danger-bg: #fee2e2;
  --radius-sm: 8px;
  --radius: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --shadow-sm: 0 1px 2px rgba(15, 26, 46, 0.05);
  --shadow: 0 4px 12px rgba(15, 26, 46, 0.06);
  --shadow-lg: 0 12px 32px rgba(15, 26, 46, 0.1);
  --container: 1180px;
  --gutter: 24px;

  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: var(--ink-800);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    color: var(--ink-900);
    font-weight: 700;
    letter-spacing: -0.01em;
  }
  p {
    margin: 0;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    background: none;
  }
  img,
  svg {
    display: block;
    max-width: 100%;
  }

  .container {
    width: 100%;
    max-width: var(--container);
    margin-left: auto;
    margin-right: auto;
    padding: 0 var(--gutter);
  }

  .section {
    padding: 72px 0;
  }

  .eyebrow {
    display: inline-block;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--green-600);
    background: var(--green-50);
    padding: 6px 12px;
    border-radius: 999px;
  }

  .section-title {
    font-size: 36px;
    line-height: 1.15;
    margin-top: 14px;
    max-width: 760px;
  }

  .section-subtitle {
    margin-top: 14px;
    color: var(--ink-700);
    font-size: 17px;
    max-width: 720px;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 22px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 15px;
    transition: transform 0.08s ease, box-shadow 0.15s ease, background 0.15s ease, color 0.15s ease;
    white-space: nowrap;
  }
  .btn:active {
    transform: translateY(1px);
  }
  .btn--primary {
    background: var(--green-500);
    color: #fff;
    box-shadow: 0 4px 14px rgba(31, 165, 107, 0.28);
  }
  .btn--primary:hover {
    background: var(--green-600);
    color: #fff;
  }
  .btn--outline {
    background: transparent;
    color: var(--ink-800);
    border: 1.5px solid var(--border-strong);
  }
  .btn--outline:hover {
    border-color: var(--ink-700);
    color: var(--ink-900);
  }
  .btn--lg {
    padding: 16px 28px;
    font-size: 16px;
  }
  .btn--block {
    width: 100%;
  }

  .chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 999px;
    background: var(--green-50);
    color: var(--green-700);
    font-size: 13px;
    font-weight: 500;
  }

  .check-circle {
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 999px;
    background: var(--green-500);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .check-circle svg {
    width: 12px;
    height: 12px;
  }

  .hero {
    background: #fff;
    padding: 72px 0 64px;
  }
  .hero__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .hero__eyebrow {
    display: inline-block;
    background: var(--green-500);
    color: #fff;
    padding: 8px 18px;
    border-radius: 999px;
    font-size: 12.5px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .hero__title {
    margin-top: 22px;
    font-size: 52px;
    line-height: 1.08;
    letter-spacing: -0.02em;
  }
  .hero__title-em {
    color: var(--green-600);
  }
  .hero__subtitle {
    margin-top: 20px;
    font-size: 18px;
    line-height: 1.55;
    color: var(--ink-700);
    max-width: 660px;
  }
  .hero__benefits {
    margin-top: 56px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 32px;
    width: 100%;
  }
  .hero__benefits li {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    color: var(--ink-800);
    font-size: 14.5px;
    line-height: 1.45;
    flex: 0 1 220px;
    text-align: center;
  }
  .hero__benefits .check-circle {
    width: 40px;
    height: 40px;
  }
  .hero__benefits .check-circle svg {
    width: 18px;
    height: 18px;
  }
  .hero__cta-row {
    margin-top: 40px;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .simulator__inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 56px;
    align-items: center;
  }
  .simulator__copy {
    max-width: 520px;
  }
  .simulator__title {
    margin-top: 14px;
    font-size: 36px;
    line-height: 1.15;
    letter-spacing: -0.02em;
  }
  .simulator__subtitle {
    margin-top: 16px;
    color: var(--ink-700);
    font-size: 17px;
    line-height: 1.55;
  }
  .simulator__bullets {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .simulator__bullets li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 15px;
    color: var(--ink-800);
  }
  .simulator__cta {
    margin-top: 28px;
  }
  .simulator__card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-xl);
    padding: 28px;
    box-shadow: var(--shadow);
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: relative;
    overflow: hidden;
  }
  .simulator__card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(to right, var(--green-500), var(--green-400));
  }
  .simulator__card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }
  .simulator__card-eyebrow {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-500);
    font-weight: 600;
  }
  .simulator__card-pill {
    background: var(--green-500);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 6px 12px;
    border-radius: 999px;
  }
  .simulator__card-plan {
    font-size: 22px;
    letter-spacing: -0.01em;
  }
  .simulator__split {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 12px;
    align-items: center;
  }
  .simulator__col {
    text-align: center;
    padding: 18px 12px;
    border: 1px dashed var(--border-strong);
    border-radius: var(--radius);
    background: var(--bg-soft);
  }
  .simulator__col--accent {
    border: 2px solid var(--green-500);
    background: var(--green-50);
  }
  .simulator__col-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 700;
    color: var(--ink-500);
  }
  .simulator__col--accent .simulator__col-label {
    color: var(--green-700);
  }
  .simulator__col-price {
    display: block;
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
    margin: 6px 0 4px;
    color: var(--ink-900);
  }
  .simulator__col--accent .simulator__col-price {
    color: var(--green-700);
  }
  .simulator__col-price--strike {
    text-decoration: line-through;
    text-decoration-color: var(--ink-400);
    color: var(--ink-500);
  }
  .simulator__col-pay {
    display: block;
    font-size: 12.5px;
    color: var(--ink-700);
  }
  .simulator__arrow {
    width: 42px;
    height: 42px;
    border-radius: 999px;
    background: var(--green-500);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    box-shadow: 0 6px 14px rgba(31, 165, 107, 0.32);
  }
  .simulator__economy {
    border-top: 1px solid var(--border);
    padding-top: 18px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }
  .simulator__economy-label {
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-500);
    font-weight: 600;
  }
  .simulator__economy-value {
    font-size: 22px;
    font-weight: 800;
    color: var(--green-700);
    letter-spacing: -0.01em;
  }

  .stats {
    background: #fff;
  }
  .stats__head {
    text-align: center;
  }
  .stats__head .section-title,
  .stats__head .section-subtitle {
    margin-left: auto;
    margin-right: auto;
  }
  .stats__grid {
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 18px;
  }
  .kpi-card {
    width: calc((100% - 36px) / 3);
    background: var(--bg-soft);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 22px 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
    overflow: hidden;
  }
  .kpi-card::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background: linear-gradient(to right, var(--green-500), var(--green-400));
    opacity: 0.6;
  }
  .kpi-card__label {
    font-size: 13px;
    color: var(--ink-500);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .kpi-card__value {
    font-size: 30px;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: var(--ink-900);
  }
  .kpi-card__delta {
    font-size: 13px;
    color: var(--ink-500);
  }
  .kpi-card__delta.is-positive {
    color: var(--green-700);
    font-weight: 600;
  }
  .stats__chart-card {
    margin-top: 32px;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 26px 28px;
    box-shadow: var(--shadow-sm);
  }
  .stats__chart-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
  }
  .stats__chart-head h3 {
    font-size: 18px;
  }
  .stats__group {
    margin-top: 40px;
  }
  .stats__group-title {
    text-align: center;
    font-size: 20px;
    letter-spacing: -0.01em;
  }
  .stats__group .stats__grid {
    margin-top: 18px;
  }
  .stats__multiples {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }
  .stats__panel-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 12px;
  }
  .stats__panel-title {
    font-size: 14px;
    font-weight: 700;
    color: var(--ink-800);
  }
  .stats__panel-chart {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 6px;
    align-items: end;
    height: 160px;
    border-bottom: 1px dashed var(--border);
    padding-bottom: 6px;
  }
  .stats__bar-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    height: 100%;
  }
  .stats__bars {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    height: 100%;
    width: 100%;
    justify-content: center;
  }
  .stats__bar {
    display: block;
    width: 10px;
    border-radius: 4px 4px 0 0;
    min-height: 6px;
  }
  .stats__bar--primary {
    background: var(--green-500);
  }
  .stats__bar-label {
    font-size: 10.5px;
    color: var(--ink-500);
    font-weight: 500;
  }

  .plans {
    background: var(--bg);
    padding: 72px 0 80px;
  }
  .plans__head {
    text-align: center;
  }
  .plans__head .section-title,
  .plans__head .section-subtitle {
    margin-left: auto;
    margin-right: auto;
  }
  .plans__cycle {
    margin: 24px auto 0;
    display: inline-flex;
    background: #fff;
    border: 1px solid var(--border);
    border-radius: 999px;
    padding: 6px;
    gap: 4px;
  }
  .plans__cycle-btn {
    padding: 12px 30px;
    font-size: 14px;
    font-weight: 600;
    color: var(--ink-700);
    border-radius: 999px;
    transition: all 0.15s ease;
  }
  .plans__cycle-btn.is-active {
    background: var(--green-500);
    color: #fff;
    box-shadow: 0 4px 12px rgba(31, 165, 107, 0.32);
  }
  .plans__grid {
    margin-top: 24px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    align-items: start;
  }
  .plan-card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 28px 26px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    box-shadow: var(--shadow-sm);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .plan-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow);
  }
  .plan-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .plan-card__head h3 {
    font-size: 20px;
    letter-spacing: -0.01em;
  }
  .plan-card__cycle-badge {
    background: var(--green-500);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 14px;
    border-radius: 6px;
    letter-spacing: 0.01em;
  }
  .plan-card__price {
    display: flex;
    flex-direction: column;
    gap: 2px;
    border-top: 1px solid var(--border);
    padding: 18px 0 4px;
  }
  .plan-card__amount {
    font-size: 22px;
    font-weight: 500;
    color: var(--ink-800);
    letter-spacing: -0.01em;
  }
  .plan-card__discounted {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-top: 14px;
  }
  .plan-card__amount-discounted {
    font-size: 26px;
    font-weight: 700;
    color: var(--green-600);
    letter-spacing: -0.01em;
  }
  .plan-card__off {
    font-size: 14px;
    color: var(--ink-700);
    font-weight: 500;
  }
  .plan-card__pay {
    font-size: 13px;
    color: var(--ink-500);
  }
  .plan-card__cta {
    letter-spacing: 0.06em;
    border-radius: 999px;
    padding: 14px 22px;
  }
  .plan-card__features {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .plan-card__features li {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 0;
    border-bottom: 1px solid var(--border);
    font-size: 13px;
    font-weight: 600;
    color: var(--ink-800);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .plan-card__features li:last-child {
    border-bottom: none;
  }
  .plan-card__features li.is-unavailable {
    color: var(--ink-500);
  }
  .plan-card__feature-name {
    flex: 1;
    min-width: 0;
  }
  .plan-card__check {
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: 999px;
    border: 1.5px solid var(--green-500);
    color: var(--green-500);
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .plan-card__x {
    flex: none;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1.5px solid #fca5a5;
    background: #fee2e2;
    color: #dc2626;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .plan-card__ia {
    background: var(--green-500);
    color: #fff;
    font-size: 10px;
    font-weight: 800;
    padding: 3px 7px;
    border-radius: 4px;
    letter-spacing: 0.06em;
  }

  .comparison {
    background: var(--bg);
  }
  .comparison__head {
    text-align: center;
  }
  .comparison__head .section-title,
  .comparison__head .section-subtitle {
    margin-left: auto;
    margin-right: auto;
  }
  .comparison__grid {
    margin-top: 24px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 22px;
  }
  .comparison__col {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    position: relative;
    overflow: hidden;
  }
  .comparison__col--lose {
    background: #fbf7f7;
  }
  .comparison__col--gain {
    border-color: rgba(31, 165, 107, 0.45);
    box-shadow: 0 12px 30px rgba(15, 110, 71, 0.1);
  }
  .comparison__col header h3 {
    margin-top: 10px;
    font-size: 22px;
  }
  .comparison__pill {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .comparison__pill--lose {
    background: var(--danger-bg);
    color: var(--danger);
  }
  .comparison__pill--gain {
    background: var(--green-50);
    color: var(--green-700);
  }
  .comparison__col ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .comparison__col li {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    font-size: 15px;
    color: var(--ink-800);
    line-height: 1.5;
  }
  .comparison__col--lose li {
    color: var(--ink-700);
  }
  .comparison__icon {
    flex: none;
    width: 22px;
    height: 22px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
  }
  .comparison__icon--lose {
    background: var(--danger-bg);
    color: var(--danger);
  }
  .comparison__icon--gain {
    background: var(--green-500);
    color: #fff;
  }

  .extras {
    background: #fff;
  }
  .extras__head {
    text-align: center;
  }
  .extras__head .section-title {
    margin-left: auto;
    margin-right: auto;
  }
  .extras__blocks {
    margin-top: 24px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  .extras__block {
    background: var(--bg-soft);
    border: 1px solid var(--border);
    border-radius: var(--radius-xl);
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    align-items: flex-start;
  }
  .extras__art {
    background: var(--green-50);
    border-radius: var(--radius-lg);
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px;
  }
  .extras__content {
    width: 100%;
  }
  .extras__content h3 {
    font-size: 22px;
    letter-spacing: -0.01em;
  }
  .extras__content p {
    margin-top: 12px;
    color: var(--ink-700);
    font-size: 15.5px;
    line-height: 1.55;
  }
  .extras__chips {
    margin-top: 18px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .final-cta {
    background: var(--bg);
  }
  .final-cta__card {
    background: linear-gradient(135deg, #0f6e47 0%, #1fa56b 100%);
    color: #fff;
    border-radius: var(--radius-xl);
    padding: 56px 48px;
    text-align: center;
    position: relative;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(15, 110, 71, 0.25);
  }
  .final-cta__card::before,
  .final-cta__card::after {
    content: '';
    position: absolute;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.07);
  }
  .final-cta__card::before {
    width: 320px;
    height: 320px;
    top: -120px;
    left: -100px;
  }
  .final-cta__card::after {
    width: 240px;
    height: 240px;
    bottom: -100px;
    right: -60px;
  }
  .final-cta__card > * {
    position: relative;
  }
  .final-cta__seal {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.1em;
    padding: 8px 16px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.25);
  }
  .final-cta__seal-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: #fcd34d;
    box-shadow: 0 0 0 4px rgba(252, 211, 77, 0.25);
  }
  .final-cta__title {
    margin-top: 22px;
    font-size: 40px;
    line-height: 1.1;
    color: #fff;
    letter-spacing: -0.02em;
  }
  .final-cta__subtitle {
    margin-top: 16px;
    font-size: 17px;
    color: rgba(255, 255, 255, 0.88);
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
  }
  .final-cta__timer {
    margin: 32px auto 0;
    display: inline-grid;
    grid-template-columns: repeat(4, minmax(78px, 1fr));
    gap: 10px;
    max-width: 480px;
  }
  .final-cta__unit {
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.24);
    border-radius: 12px;
    padding: 12px 8px;
    text-align: center;
  }
  .final-cta__unit-value {
    display: block;
    font-size: 28px;
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
  }
  .final-cta__unit-label {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    opacity: 0.85;
    margin-top: 2px;
  }
  .final-cta__actions {
    margin-top: 32px;
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .final-cta__actions .btn--primary {
    background: #fff;
    color: var(--green-700);
  }
  .final-cta__actions .btn--primary:hover {
    background: #f4fff8;
    color: var(--green-700);
  }
  .final-cta__outline {
    border-color: rgba(255, 255, 255, 0.6);
    color: #fff;
  }
  .final-cta__outline:hover {
    border-color: #fff;
    color: #fff;
  }
  .final-cta__trust {
    margin-top: 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.92);
  }
  .final-cta__trust span {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .site-footer {
    background: #fff;
    border-top: 1px solid var(--border);
    padding: 28px 0;
  }
  .site-footer__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 14px;
    color: var(--ink-700);
  }
  .site-footer a {
    color: var(--green-600);
    font-weight: 600;
  }
  .site-footer a:hover {
    color: var(--green-700);
  }
  .site-footer__brand {
    font-size: 13px;
    color: var(--ink-500);
  }

  .floating-cta {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 60;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 14px 20px;
    background: var(--green-500);
    color: #fff;
    border-radius: 999px;
    font-weight: 600;
    font-size: 14.5px;
    box-shadow: 0 12px 28px rgba(15, 110, 71, 0.36);
    transition: transform 0.2s ease, opacity 0.2s ease, background 0.15s ease;
    opacity: 0;
    transform: translateY(20px);
    pointer-events: none;
  }
  .floating-cta.is-visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
  .floating-cta:hover {
    background: var(--green-600);
  }

  @media (max-width: 1080px) {
    .kpi-card {
      width: calc((100% - 18px) / 2);
    }
    .plans__grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 900px) {
    .section {
      padding: 56px 0;
    }
    .section-title {
      font-size: 28px;
    }
    .hero {
      padding: 48px 0 40px;
    }
    .hero__title {
      font-size: 32px;
    }
    .hero__subtitle {
      font-size: 16px;
    }
    .hero__benefits li {
      flex: 1 1 100%;
    }
    .simulator__inner {
      grid-template-columns: 1fr;
      gap: 32px;
    }
    .simulator__title {
      font-size: 28px;
    }
    .comparison__grid {
      grid-template-columns: 1fr;
    }
    .extras__blocks {
      grid-template-columns: 1fr;
    }
    .stats__multiples {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 760px) {
    .final-cta__card {
      padding: 36px 22px;
    }
    .final-cta__title {
      font-size: 28px;
    }
  }

  @media (max-width: 600px) {
    .stats__panel-chart {
      gap: 4px;
    }
    .stats__bar {
      width: 6px;
    }
    .plans__cycle-btn {
      padding: 10px 18px;
      font-size: 13px;
    }
    .floating-cta {
      right: 16px;
      bottom: 16px;
      padding: 12px 16px;
      font-size: 13.5px;
    }
  }

  @media (max-width: 540px) {
    .simulator__split {
      grid-template-columns: 1fr;
    }
    .simulator__arrow {
      transform: rotate(90deg);
    }
  }
`;
